import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import { USER_READ, hasPrivilege } from 'utils/privileges';
import config from 'utils/config';
import { setAlert, setSuccessAlert } from 'actions/alerts';
import { playlistQueryKeys, useUpdatePlaylistAutoShares } from 'actions/playlists';
import { EditorPageStickySaveDiscardButton } from 'components/EditorPageStickyFooter';
import { AutoShareField, ShareableLinkField, ShareNowField } from 'components/FormFields';
import FormStack from 'components/FormStack';
import { DefaultFormFieldLayout } from 'components/FormField';
import Stack from 'components/Stack';
import TitleCard from 'components/TitleCard';
import UnsavedChangesPrompt from 'components/UnsavedChangesPrompt';
import NudgesOverviewCard from 'components/NudgesOverviewCard';
import usePlaylistAutoShareForm from './usePlaylistAutoShareForm';
function SinglePlaylistSharePage(_ref) {
  var playlistId = _ref.playlistId,
    autoShareData = _ref.autoShareData,
    shareData = _ref.shareData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSaving = _useState2[0],
    setIsSaving = _useState2[1];
  var _usePlaylistAutoShare = usePlaylistAutoShareForm({
      autoShareData: autoShareData
    }),
    fields = _usePlaylistAutoShare.fields,
    wasChanged = _usePlaylistAutoShare.wasChanged,
    hasErrors = _usePlaylistAutoShare.hasErrors,
    reset = _usePlaylistAutoShare.reset;
  var _useUpdatePlaylistAut = useUpdatePlaylistAutoShares({
      playlistId: playlistId
    }),
    updatePlaylistAutoShares = _useUpdatePlaylistAut.updatePlaylistAutoShares;
  function handleSubmit(_x) {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var promises;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            setIsSaving(true);
            promises = [];
            if (fields.autoShare.wasChanged) {
              promises.push(updatePlaylistAutoShares(fields.autoShare.value));
            }
            _context.prev = 4;
            _context.next = 7;
            return Promise.all(promises);
          case 7:
            setSuccessAlert({
              title: t('alert_playlist_sharing_update_success')
            });
            _context.next = 10;
            return queryClient.invalidateQueries(playlistQueryKeys.allPlaylists);
          case 10:
            reset();
            _context.next = 18;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](4);
            setAlert({
              key: 'playlist-share-error',
              title: t('alert_playlist_sharing_update_error'),
              message: _context.t0.message
            });
            _context.next = 18;
            return queryClient.invalidateQueries(playlistQueryKeys.allPlaylists);
          case 18:
            setIsSaving(false);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 13]]);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(UnsavedChangesPrompt, {
    hasUnsavedChanges: wasChanged
  }), /*#__PURE__*/React.createElement(Stack, {
    spacing: "m"
  }, shareData && /*#__PURE__*/React.createElement(TitleCard, {
    title: t('actions_share_now')
  }, /*#__PURE__*/React.createElement(DefaultFormFieldLayout, {
    horizontal: true
  }, /*#__PURE__*/React.createElement(FormStack, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(ShareNowField, {
    shareData: shareData
  }), /*#__PURE__*/React.createElement(ShareableLinkField, {
    contentId: playlistId,
    type: "playlist"
  })))), config.autoSharing && hasPrivilege(USER_READ) && /*#__PURE__*/React.createElement(TitleCard, {
    title: t('playlist_access_auto_sharing_title'),
    description: t('hint_autoshare_field')
  }, /*#__PURE__*/React.createElement(DefaultFormFieldLayout, {
    horizontal: true
  }, /*#__PURE__*/React.createElement(FormStack, null, /*#__PURE__*/React.createElement(AutoShareField, {
    playlistId: playlistId,
    audience: autoShareData.audience,
    teams: autoShareData.teams,
    value: fields.autoShare.value,
    wasAutoShareChanged: fields.autoShare.wasChanged,
    onChange: fields.autoShare.set
  })))), /*#__PURE__*/React.createElement(NudgesOverviewCard, {
    contentId: autoShareData.id,
    type: "playlist"
  })), /*#__PURE__*/React.createElement(EditorPageStickySaveDiscardButton, {
    hasChanges: wasChanged,
    isDisabled: hasErrors,
    isSaving: isSaving,
    onDiscard: function onDiscard() {
      return reset();
    }
  }));
}
export default SinglePlaylistSharePage;